/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.set.defs'

export { $nsid }

type Set$0 = {
  $type?: 'tools.ozone.set.defs#set'
  name: string
  description?: string
}

export type { Set$0 as Set }

const set$0 = l.typedObject<Set$0>(
  $nsid,
  'set',
  l.object({
    name: l.string({ minLength: 3, maxLength: 128 }),
    description: l.optional(l.string({ maxGraphemes: 1024, maxLength: 10240 })),
  }),
)

export { set$0 as 'set' }

type SetView = {
  $type?: 'tools.ozone.set.defs#setView'
  name: string
  description?: string
  setSize: number
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { SetView }

const setView = l.typedObject<SetView>(
  $nsid,
  'setView',
  l.object({
    name: l.string({ minLength: 3, maxLength: 128 }),
    description: l.optional(l.string({ maxGraphemes: 1024, maxLength: 10240 })),
    setSize: l.integer(),
    createdAt: l.string({ format: 'datetime' }),
    updatedAt: l.string({ format: 'datetime' }),
  }),
)

export { setView }
